import React, { useState, useEffect } from "react";
import { Button, Card, Form, Container } from "react-bootstrap";

import { FormHelper } from "utils";
import useMessage from "hooks/useMessage";
import { useTheme, useAuthentication } from "hooks";
import useExceptionHandler from "hooks/useExceptionHandler";
import { AnimatedIconButton } from "components/AnimatedIconButton/AnimatedIconButton";

export function TwoFactorPage({ showLoading, hideLoading }) {
  const [cardClasses, setCardClasses] = useState("card-hidden");
  const [codigo, setCodigo] = useState("");
  const [confiarDispositivo, setConfiarDispositivo] = useState(false);

  const { theme } = useTheme();
  const { verify2fa, resend2fa, cancelar2FA } = useAuthentication();
  const { Message, cerrarAlertas } = useMessage();
  const { handleException } = useExceptionHandler();

  useEffect(() => {
    setTimeout(() => setCardClasses(""), 1000);
    return () => {
      cerrarAlertas();
    };
  }, []);

  const onCodigoChange = (e) => {
    // Solo dígitos, máximo 5.
    const valor = (e.target.value || "").replace(/\D/g, "").slice(0, 5);
    setCodigo(valor);
  };

  const onSubmit = (e) => {
    FormHelper.handleSubmit(e);
    if (codigo.length !== 5) {
      Message({ message: "Ingrese el código de 5 dígitos." });
      return;
    }
    showLoading();
    verify2fa(codigo, confiarDispositivo)
      .catch((error) => {
        hideLoading();
        handleException(error);
      });
  };

  const onKeyDownEvent = (e) => {
    if (e.keyCode === 13) {
      onSubmit(e);
    }
  };

  const onReenviar = () => {
    showLoading();
    resend2fa()
      .then(() => Message({ message: "Le enviamos un nuevo código a su correo." }))
      .catch((error) => handleException(error))
      .finally(() => hideLoading());
  };

  return (
    <div className="full-page section-image" data-color="black">
      <div className="content d-flex align-items-center justify-content-center p-0">
        <Container
          className="d-flex align-items-center justify-content-center"
          style={{ maxWidth: "65%", minWidth: "65%" }}
        >
          <Card
            className={"card-login" + cardClasses}
            style={{ minWidth: "20rem", maxWidth: "40rem" }}
          >
            <Card.Header className="text-center">
              {theme.logo ? (
                <img
                  style={{ objectFit: "contain" }}
                  alt="logo"
                  src={theme.logo}
                  height="80px"
                  width="275px"
                />
              ) : (
                theme.appName
              )}
            </Card.Header>
            <Card.Body
              style={{
                flexDirection: "column",
                alignContent: "center",
                justifyContent: "center",
                alignItems: "center",
                paddingBottom: "0px",
              }}
            >
              <Form className="form" onSubmit={onSubmit}>
                <p className="text-center" style={{ marginBottom: "20px" }}>
                  Le enviamos un código de verificación a su correo. Ingréselo para continuar.
                </p>
                <Form.Group>
                  <label>Código de verificación</label>
                  <Form.Control
                    autoComplete="one-time-code"
                    name="codigo"
                    type="text"
                    inputMode="numeric"
                    maxLength={5}
                    value={codigo}
                    onChange={onCodigoChange}
                    onKeyDown={onKeyDownEvent}
                    style={{ letterSpacing: "8px", textAlign: "center", fontSize: "22px" }}
                  />
                </Form.Group>
                <Form.Group>
                  <label>Recordar este dispositivo</label>
                  <Form.Check
                    type="switch"
                    id="swConfiarDispositivo"
                    name="confiarDispositivo"
                    checked={confiarDispositivo}
                    onChange={(e) => setConfiarDispositivo(e.target.checked)}
                  />
                </Form.Group>
              </Form>
            </Card.Body>
            <Card.Footer className="p-0 ml-auto mr-auto">
              <AnimatedIconButton
                key={"submit2faBtn"}
                size="60px"
                height="35px"
                width="35px"
                iconName="key"
                message="Verificar"
                style={{ padding: "0px" }}
                onClick={(e) => onSubmit(e)}
                useVendorTheme={true}
              />
            </Card.Footer>
            <div className="d-flex justify-content-between">
              <Button
                variant="link"
                type="button"
                style={{ color: theme.color1, paddingTop: "20px" }}
                onClick={onReenviar}
              >
                Reenviar código
              </Button>
              <Button
                variant="link"
                type="button"
                style={{ color: theme.color1, paddingTop: "20px" }}
                onClick={cancelar2FA}
              >
                Volver al inicio
              </Button>
            </div>
          </Card>
        </Container>
      </div>
    </div>
  );
}
